module.exports = __webpack_public_path__ + "images/job/detail/detail_icon07-b318255179a298acc724347da74e870e.png";